import React, { useState, useEffect } from 'react'
import BuyerRequest from '../Modules/BuyerUser/Request'
import {DataBuyer} from '../Modules/BuyerUser/DataBuyer'

interface BuyerUserHookResult {
  dataBuyer: DataBuyer 
  loading: boolean
  error: any
  u: string
}

export const useBuyerUser = (publicToken): BuyerUserHookResult => {
  const [dataBuyer, setDataBuyer] = useState<DataBuyer>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<any>(null)
  
  const querystring = window.location.search
  const params = new URLSearchParams(querystring)
  
  useEffect(() => {
    if (params.has('u')) {
      setLoading(true)
      setError(null) // Clear previous errors
      BuyerRequest.getBuyerUser(publicToken, params.get('u'))
        .then(result => {
          console.log('result: ', result)
          setDataBuyer(result.toSend?.buyerUser)
        })
        .catch((err) => {
          console.error('error getBuyer - error: ', err)
          setError(err)
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [])

  // @ts-ignore
  return { dataBuyer, loading, error, u: params.get('u') }
}